/**
 * Tutorial guidato delle Unita' di misura.
 *
 * Un preparativo solo: il riquadro della prima unita', che il passo dedicato apre
 * per mostrare i campi delle traduzioni. `stopUnitTour` lo richiude a fine giro, e
 * solo se ad aprirlo e' stato il tutorial. Gli interruttori non si toccano.
 */
const SCOPE = '[data-tour-scope="setting-unit"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let opened = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre il riquadro della prima unita', se non e' gia' aperto. */
function openFirst() {
	if (visible(at('settings'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		opened = true;
		toggle.click();
	}
}

/** Richiude il riquadro aperto dal tutorial. */
export function stopUnitTour() {
	if (!opened) return;

	opened = false;

	if (visible(at('settings'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function createUnitTourSteps() {
	return [
		{
			body: "Le unita' con cui si misurano i prodotti - pezzi, chili, litri, metri. Compaiono nella scheda del prodotto e accanto alla quantita' in tutti i documenti, quindi sono poche e cambiano di rado.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: "Le unita' di misura",
		},
		{
			body: "Una riga per unita', con lo stato e l'etichetta Predefinita su quella proposta di default. La predefinita e' quella che viene proposta a ogni prodotto nuovo: conviene sia quella che usi piu' spesso.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "Il piu' a inizio riga apre le traduzioni dell'unita': il nome con cui viene scritta in ogni lingua attiva, una lingua per tab, perche' e' una parola che il cliente legge sul sito. Accanto alle tab ci sono Copia su tutte e Traduci per non riscriverle a mano.",
			before: stopUnitTour,
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			timeout: 400,
			title: 'Aprire le traduzioni',
		},
		{
			body: "Le traduzioni si scrivono qui dentro e si confermano con Salva. Attenzione a scrivere l'unita' come la userebbe un cliente - kg, non chilogrammi - perche' finisce accanto ai numeri in spazi stretti.",
			before: openFirst,
			key: 'settings',
			placement: 'right',
			target: at('settings'),
			timeout: 600,
			title: 'Le traduzioni',
		},
		{
			body: "L'interruttore accende e spegne l'unita', e salva subito.",
			key: 'switch',
			missing: 'skip',
			placement: 'right',
			target: at('switch'),
			title: "Accendere un'unita'",
		},
		{
			body: "I tre puntini a inizio riga permettono di renderla predefinita o di eliminarla, con una conferma. La predefinita non li ha, proprio per non restare senza: per cambiarla si rende predefinita un'altra.",
			key: 'row-menu',
			missing: 'skip',
			placement: 'right',
			target: at('row-menu'),
			title: 'Predefinita ed eliminazione',
		},
		{
			body: "Da qui si aggiunge un'unita' nuova: il nome in ogni lingua attiva e se nasce gia' attiva.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: "Aggiungere un'unita'",
		},
	];
}
